import { COLORS, DSTooltip, DSTooltipProps } from '@repo/design-system/index'
import { QIcon_bell_default } from '@repo/icons/index'
import { subHeaderClassName } from '../../style'

interface SectionTooltipProps {
  text: string
  place: DSTooltipProps['place']
  isMultiline: boolean
  remountFlag: boolean
}

const TextClose = ({ text, place, isMultiline, remountFlag }: SectionTooltipProps) => {
  return (
    remountFlag && (
      <div className="mt-[20px]">
        <p className={subHeaderClassName}>Text Close</p>
        <div className="flex h-[200px] w-[800px] flex-row items-center justify-center">
          <DSTooltip
            place={place}
            hasCloseButton
            isMultiline={isMultiline}
            triggerComponent={<QIcon_bell_default color={COLORS.PURPLE} />}
            contentComponent={text}
          />
        </div>
      </div>
    )
  )
}

export default TextClose
